import { IShipmentService } from '../@posturinn/client-react';
import {
	FETCH_COUNTRIES_FAILED,
	FETCH_COUNTRIES_FULFILLED,
	FETCH_COUNTRIES_PENDING,
} from '../constants/actions/countriesReducer';

export const fetchCountriesPending = () => ({
	type: FETCH_COUNTRIES_PENDING,
	payload: null,
});

export const fetchCountriesFulfilled = countries => ({
	type: FETCH_COUNTRIES_FULFILLED,
	payload: {
		countries,
	},
});

export const fetchCountriesFailed = error => ({
	type: FETCH_COUNTRIES_FAILED,
	payload: {
		error,
	},
});

export const fetchCountries = (lang: string, filter: boolean = false) => {
	return async (dispatch, getState) => {
		dispatch(fetchCountriesPending());
		const { injector } = getState().mobizReducer;
		const shipmentService: IShipmentService = injector.get(IShipmentService);
		try {
			shipmentService.getCountries(lang).subscribe({
				next: response => {
					const commonCountries = [];
					const countries = [];

					const common = ['IS', 'US', 'GB', 'DK', 'NO', 'SE', 'FR', 'DE', 'ES', 'PL', 'CA'];

					for (let i = 0; response[i]; i++) {
						const country = {
							label: response[i].name,
							value: response[i].countryCode,
							telephoneCode: response[i].telephoneCode,
							isClosed: response[i].isClosed,
							closedExplanation: response[i].closedExplanation || '',
							requiresBusinessAccountForCompanySender:
								response[i].requiresBusinessAccountForCompanySender,
							requiresMerchProdId: response[i].requiresMerchProdId,
						};
						if (filter && common.includes(response[i].countryCode.toUpperCase()))
							commonCountries.push(country);
						else countries.push(country);
					}
					dispatch(fetchCountriesFulfilled(commonCountries.concat(countries)));
				},
				error: error => {
					dispatch(fetchCountriesFailed(error));
				},
			});
		} catch (error) {
			dispatch(fetchCountriesFailed(error));
		}
	};
};
